import * as React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import formatedDate from '../../../shared/util/formatCardDate';
import VisaLogo from '../../../icons/visaLogo.svg';
import MastercardLogo from '../../../icons/mastercardLogo.svg';
import DBPayMethodBackground from '../../../icons/DBPayMethod.svg';
import BankPayMethodBackground from '../../../icons/BankPayMethod.svg';
import CCPayMethodBackground from '../../../icons/CCPayMethod.svg';
import Amex from "../../../icons/AMEX.svg";
import Discover from "../../../icons/Discover.svg";

const useStyles = makeStyles({
  cardNumber: {
    marginLeft: '14px',
  },
});

interface PayMethodPropsType {
  CardElypse: string;
  method: any;
  imageStyle?: React.CSSProperties | undefined;
  isBankAccount?: boolean;
  newData?: any;
  paymentUuid?: string;
  disabled?: boolean;
  baseMethodParams: { height: string; width: string; border: string; borderRadius: string };
  clickedMethodParams?: { height: string; width: string; border: string; borderRadius: string };
  setPaymentUuid?: (value: React.SetStateAction<string>) => void;
  handlePaymentMethodClicked: (method: any) => void;
}

const setBackgroundImage = (method: any): string => {
  // TODO: check if card is disabled as well
  return method?.CardType === 'DB' ? DBPayMethodBackground : method?.CardType === 'CC' ? CCPayMethodBackground : BankPayMethodBackground;
};

const setLogo = (method: any): string => {
  switch (method.CardNetwork?.toLowerCase()) {
    case 'visa':
      return VisaLogo;
    case 'mastercard':
      return MastercardLogo;
    case 'amex':
    case 'american express':
      return Amex;
    case 'discover':
      return Discover;
      default:
    return VisaLogo
  }
};

export default function PayMethodComponent(props: PayMethodPropsType) {
  const classes = useStyles();
  const { disabled, isBankAccount, baseMethodParams, clickedMethodParams, method, newData, paymentUuid, setPaymentUuid, CardElypse, handlePaymentMethodClicked } = props;
  const backgroundImage = setBackgroundImage(method);
  const logo = setLogo(method);

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        filter: disabled ? 'opacity(50%)' : '',
        backgroundRepeat: 'no-repeat',
        backgroundSize: paymentUuid && paymentUuid === method?.Uuid ? `${clickedMethodParams?.width} ${clickedMethodParams?.height}` : `${baseMethodParams.width} ${baseMethodParams.height}`,
        height: paymentUuid && paymentUuid === method?.Uuid ? clickedMethodParams?.height : baseMethodParams.height,
        width: paymentUuid && paymentUuid === method?.Uuid ? clickedMethodParams?.width : baseMethodParams.width,
        cursor: disabled ? 'not-allowed': 'pointer',
        border: paymentUuid === method?.Uuid ? clickedMethodParams?.border : baseMethodParams.border,
        borderRadius: paymentUuid === method?.Uuid ? clickedMethodParams?.borderRadius : baseMethodParams.borderRadius,
      }}
      onClick={
        disabled
          ? () => {}
            : setPaymentUuid
              ? () => {
                  handlePaymentMethodClicked(method);
                  const onePayment = newData?.find((data: any) => data?.Uuid === method?.Uuid);
                  if (onePayment) {
                    setPaymentUuid(onePayment.Uuid);
                  }
                }
              : () => {}
      }
      otp-paytype={isBankAccount ? 'bank-account' : 'card'}
      className={paymentUuid === method?.Uuid ? 'paymethod-tile active' : 'paymethod-tile'}
    >
      {isBankAccount ? (
        <>
          <Typography
            style={{
              fontFamily: "'Work Sans', sans-serif",
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '21px',
              color: '#000000',
              marginLeft: '10px',
              paddingTop: paymentUuid === method?.Uuid ? '' : '50px',
              marginTop: paymentUuid === method?.Uuid ? '57px' : '',
              marginBottom: paymentUuid === method?.Uuid ? '22px' : '14px',
              height: paymentUuid === method?.Uuid ? 21 : 71,
            }}
          >
            {method?.NickName ? `${method?.NickName.slice(0, 9)}...` : ''}
          </Typography>
          <Typography
            style={{
              fontFamily: "'Work Sans', sans-serif",
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '21px',
              color: '#14142B',
              marginLeft: '10px',
              paddingTop: '45px',
            }}
          >
            <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" />
            {'  '}
            <span className={classes.cardNumber}>{method?.AccountLastFour}</span>
          </Typography>
        </>
      ) : (
        <>
          <img
            src={logo}
            alt="logo"
            style={{
              height: '13px',
              width: '21px',
              marginLeft: '9px',
              marginTop: '10%',
              marginBottom: paymentUuid && paymentUuid === method?.Uuid ? '22px' : '14px',
            }}
          />
          <Typography
            style={{
              fontFamily: "'Work Sans', sans-serif",
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '21px',
              color: '#000000',
              marginLeft: '10px',
              marginBottom: paymentUuid === method?.Uuid ? '16px' : '15px',
              height: 21,
            }}
          >
            {method?.NickName ? `${method?.NickName.slice(0, 9)}...` : ''}
          </Typography>
          <Typography
            style={{
              fontFamily: "'Work Sans', sans-serif",
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '12px',
              lineHeight: '14px',
              color: '#14142B',
              opacity: 0.5,
              marginLeft: '8px',
              marginBottom: paymentUuid === method?.Uuid ? '8px' : '7px',
            }}
          >
            {`${method?.CardNetwork?.slice(0,12)}`}
          </Typography>
          <Typography
            style={{
              fontFamily: "'Work Sans', sans-serif",
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '21px',
              color: '#14142B',
              marginLeft: '8px',
              marginBottom: paymentUuid === method?.Uuid ? '23px' : '17px',
            }}
          >
            <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" />
            {'  '}
            <span className={classes.cardNumber}>{method?.AccountLastFour}</span>
          </Typography>
          <Typography id="cardDates">{formatedDate(method?.ExpirationDate)}</Typography>
        </>
      )}
    </div>
  );
}
